<h1 class="accent-background-element">Edit Clinic/Office</h1>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="row">
      <div class="column">
        <h4>Country</h4>
        <div>
          <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
            <mat-select formControlName="country" class='accent-border-element  mat-body'
              placeholder="Country">
              @for (countryID of CountriesIDs | keyvalue; track countryID) {
                <mat-option class='accent-hover-element'
                [value]='countryID.value'>{{this.getFullCountryNameById(countryID.value)}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @if (isPhysical) {
        <div  class="shown">
          <h4>Show on map:&nbsp;</h4>
          <div>
            <mat-slide-toggle formControlName="show"></mat-slide-toggle>
          </div>
        </div>
      }
    </div>
    <div class="row">
      <div class="inner-row">
        <h4>Type 1*:</h4>
        <div>
          <mat-radio-group formControlName="type1">
            <mat-radio-button [value]="ShopTypesEnum.clinic"> Clinic</mat-radio-button>
            <mat-radio-button [value]="ShopTypesEnum.entOffice"> ENT Office </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="inner-row">
        <h4>Subtype*: </h4>
        <div>
          <mat-radio-group formControlName="type2">
            <mat-radio-button [value]="ClinicTypesEnum.physical">{{
            ClinicTypesEnum.physical| titlecase}}</mat-radio-button>
            <mat-radio-button
            [value]="ClinicTypesEnum.digital">{{ClinicTypesEnum.digital | titlecase}}</mat-radio-button>
            <mat-radio-button
            [value]="ClinicTypesEnum.parking">{{ClinicTypesEnum.parking| titlecase}}</mat-radio-button>
          </mat-radio-group>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="column">
        <h4>Clinic / Office ID*</h4>
        <div>
          <input placeholder="Clinic / Office ID" formControlName="clinicOfficeId"
            class="accent-border-element mat-body "
            [ngClass]="{'warn-border-element':((form.controls['clinicOfficeId'].dirty || form.controls['clinicOfficeId'].touched) && form.controls['clinicOfficeId'].invalid )}">

      </div>
    </div>
    <div class="column">
      <h4>Clinic / Office name*</h4>
      <div>
        <input placeholder="Clinic / Office name" formControlName="name"
          class="accent-border-element mat-body "
          [ngClass]="{'warn-border-element':((form.controls['name'].dirty || form.controls['name'].touched) && form.controls['name'].invalid )}">

    </div>
  </div>

</div>
<div class="row">
  <div class="column">
    <h4>E-mail</h4>
    <div>
      <input placeholder="E-mail" formControlName="email" class="accent-border-element mat-body "
        [ngClass]="{'warn-border-element':((form.controls['email'].dirty || form.controls['email'].touched) && form.controls['email'].invalid )}">

  </div>
</div>
<div class="column" >
  <h4>Phone </h4>
  <div>
    <input placeholder="Phone" formControlName="phone" class="accent-border-element mat-body " type="tel"
      [ngClass]="{'warn-border-element':((form.controls['phone'].dirty || form.controls['phone'].touched) && form.controls['phone'].invalid )}">

    </div>
  </div>
</div>
<div class="row">

@if (isUs) {
  <div class="column">
    <h4>CRM*</h4>
    <div>
      <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
        <mat-select formControlName="crm" class='accent-border-element  mat-body'
          placeholder="Choose CRM">
          <mat-option class='accent-hover-element' [value]='4'>{{getCRMNameByNumber(4)}}
          </mat-option>
          <mat-option class='accent-hover-element' [value]='5'>{{getCRMNameByNumber(5)}}
          </mat-option>
          <mat-option class='accent-hover-element' [value]='6'>{{getCRMNameByNumber(6)}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
@if (isOffice) {
  <div class="column">
    <h4>Website</h4>
    <div>
      <input placeholder="Website" formControlName="website"
        class="accent-border-element mat-body "
        [ngClass]="{'warn-border-element':((form.controls['website'].dirty || form.controls['website'].touched) && form.controls['website'].invalid )}">
      </div>
    </div>
  }
</div>
@if (isPhysical ||(!isPhysical && isUs)) {
  <mat-divider ></mat-divider>
}
@if (isPhysical) {
  <div class="row" >
    <div class="column full-width">
      <h4>Coordinates*</h4>
      <div class="coordinates">
        <input placeholder="i.e. 50.842989, 4.366965" formControlName="coordinates"
          class="accent-border-element mat-body "
          [ngClass]="{'warn-border-element':((form.controls['coordinates'].dirty || form.controls['coordinates'].touched) && form.controls['coordinates'].invalid )}">
      <button color="accent" mat-raised-button (click)="openMap()">
        Select on Map
        <mat-icon fontIcon="map"></mat-icon>
      </button>
    </div>
  </div>
</div>
}

@if (isPhysical) {
  <div class="row">
    <div class="column">
      <h4>City*</h4>
      <div>
        <input placeholder="City" formControlName="city" class="accent-border-element mat-body "
          [ngClass]="{'warn-border-element':((form.controls['city'].dirty || form.controls['city'].touched) && form.controls['city'].invalid )}">
    </div>
  </div>
  <div class="column">
    <h4>Zip Code*</h4>
    <div>
      <input placeholder="Zip Code" formControlName="zipCode" class="accent-border-element mat-body "
        [ngClass]="{'warn-border-element':((form.controls['zipCode'].dirty || form.controls['zipCode'].touched) && form.controls['zipCode'].invalid )}">
  </div>
</div>
</div>
}
@if (isPhysical) {
  <div class="row">
    <div class="column">
      <h4>Address Line 1*</h4>
      <div>
        <input placeholder="Address Line 1" formControlName="addressLine1"
          class="accent-border-element mat-body "
          [ngClass]="{'warn-border-element':((form.controls['addressLine1'].dirty || form.controls['addressLine1'].touched) && form.controls['addressLine1'].invalid )}">
    </div>
  </div>
  <div class="column">
    <h4>Address Line 2</h4>
    <div>
      <input placeholder="Address Line 2" formControlName="addressLine2"
        class="accent-border-element mat-body "
        [ngClass]="{'warn-border-element':((form.controls['addressLine2'].dirty || form.controls['addressLine2'].touched) && form.controls['addressLine2'].invalid )}">
  </div>
</div>
</div>
}
@if (isUs) {
  <div class="row">
    <div class="column">
      <h4>State</h4>
      <div>
        <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
          <mat-select formControlName="state" class='accent-border-element  mat-body'
            placeholder="State">
            @for (state of UsaStatesEnum | keyvalue; track state) {
              <mat-option class='accent-hover-element' [value]='state.key'>{{state.value}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
}


@if (isPhysical) {
  <mat-divider></mat-divider>
}
@if (isPhysical && !isOffice) {
  <form [formGroup]="week" class="week-form">
    <h4>Opening hours: </h4>
    @for (day of Object.keys(this.week.controls); track day) {
      <div class="hours">
        <div class="flex">
          <div class="day"> {{day}}:</div>
          <form [formGroupName]="day">
            @if (Object.keys(getDay(day).controls).length==0) {
              <span><i>Closed</i></span>
            }
            @for (controlGroup of (getDay(day).controls); track controlGroup; let i = $index) {
              <div>
                <ng-container [formGroup]="getFormGroup(controlGroup) ">
                  <input type="time" formControlName="start" />&nbsp;‒&nbsp;
                  <input type="time" formControlName="end" />
                </ng-container>
              </div>
            }
          </form>
        </div>
        <div class="buttons">
          @if (Object.keys(getDay(day).controls).length>0) {
            <button mat-icon-button
              (click)="removeFromDay(day)"><mat-icon fontIcon="remove"></mat-icon></button>
            }
            @if (Object.keys(getDay(day).controls).length<2) {
              <button mat-icon-button
                (click)="addTimeToDay(day)"><mat-icon fontIcon="add"></mat-icon></button>
              }
            </div>
          </div>
        }
      </form>
    }

    @if (isOffice) {
      <div class="ent-names-form">
        <h4>ENT Names: </h4>
        <div class="flex">
          <form formGroupName="entNames" class="ent-names">
            @if (Object.keys(getEntNames().controls).length>0) {
              <span></span>
            } @else {
              <mat-icon svgIcon='dash'></mat-icon>
            }
            @for (controlGroup of (getEntNames().controls); track controlGroup; let i = $index) {
              <div class="ent-name">
                <span class="index">{{i+1}}.&nbsp;</span>
                <ng-container [formGroup]="getFormGroup(controlGroup) ">
                  <input formControlName="firstName" placeholder="First Name" [ngClass]="{'warn-border-element': hasError(controlGroup, 'firstName')}"/>&nbsp;&nbsp;
                  <input formControlName="lastName" placeholder="Last Name" [ngClass]="{'warn-border-element': hasError(controlGroup, 'lastName')}"/>
                </ng-container>
                <span class="spacer"></span>
                <button mat-icon-button (click)="removeEntName(i)"><mat-icon
                fontIcon="remove"></mat-icon></button>
              </div>
            }
          </form>
        </div>
        <div class="buttons">
          <span class="spacer"></span>
          <button mat-icon-button (click)="addToEntNames()"><mat-icon fontIcon="add"></mat-icon></button>
        </div>
      </div>
    }
</form>

</mat-dialog-content>

<mat-dialog-actions>

  @if (isDeletable()) {
    <button mat-raised-button color="warn" (click)="openDeleteClinicDialog()">Delete Clinic/Office</button>
  }
  <div class="spacer"></div>
  <button mat-raised-button color="accent" [disabled]="isDisabledButton()" (click)="onSubmit()">Continue</button>
</mat-dialog-actions>


